import { render } from "./FormOrderProducts.vue?vue&type=template&id=7bebc435"
import script from "./FormOrderProducts.vue?vue&type=script&lang=js"
export * from "./FormOrderProducts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/FormCustom/FormOrderProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bebc435"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bebc435', __exports__)) {
    console.log('reload')
    api.reload('7bebc435', __exports__)
  }
  
  module.hot.accept("./FormOrderProducts.vue?vue&type=template&id=7bebc435", () => {
    console.log('re-render')
    api.rerender('7bebc435', render)
  })

}


export default __exports__